export default "__VITE_ASSET__Db31TTse__"